<script>
import { mapActions } from 'vuex'

export default {
  name: 'RetailerRemoveModal',
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      progress: false,
    }
  },
  methods: {
    ...mapActions('retailer', ['deleteRetailer']),
    async onSubmit() {
      this.progress = true

      await this.deleteRetailer(this.id).then(response => {
        this.$notifier({
          response,
          errorTitle: 'Unable to delete retailer',
          successTitle: 'Retailer deleted',
          successMsg: 'Retailer successfully deleted.',
        }).then(success => {
          if (success) {
            this.$emit('close-modal')
          }
        })
      })

      this.progress = false
    },
  },
}
</script>

<template>
  <state-dialog
    title="Delete Retailer"
    brand="danger"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <el-icon
      slot="icon"
      name="warning-outline"
    />
    <el-button
      slot="subicon"
      icon="el-icon-delete"
      type="danger"
      circle
    />
    <div :class="$style.msg">
      Are you sure you wish to delete this retailer?
    </div>
    <div class="modal__footer">
      <el-button
        type="danger"
        :disabled="progress"
        class="el-button--wide"
        @click.stop="onSubmit"
      >
        Delete Retailer
      </el-button>
    </div>
  </state-dialog>
</template>

<style lang="scss" module>
  .msg {
    word-break: normal;
  }
</style>
